export const segmentsMatch = (segmentsString, key) => segmentsString && key ? segmentsString.split('-').every((seg) => key.includes(seg)) : false;
export const isAllBlocklisted = (blocklistArray = [], key) => blocklistArray.some((entry) => segmentsMatch(entry, key));
